import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { axiosLib } from '@/lib/axios';
import { getColocApiCallProperties } from '@/lib/coloc-api';
import { showToast } from '@/services/toast-service';

export const useWatchToggle = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const handleWatchToggle = async (slug: string, isWatched: boolean): Promise<boolean> => {
    try {
      console.log('Attempting to toggle watch for:', slug, isWatched);

      // Try to get the current watch status from the API
      if (isWatched) {
        await axiosLib.delete(`/colocations/${slug}/unwatch`, {
          ...getColocApiCallProperties(),
        });
      } else {
        await axiosLib.post(`/colocations/${slug}/watch`, null, {
          ...getColocApiCallProperties(),
        });
      }

      const isCurrentlyWatched = response.data?.is_watched || false;
      console.log('Current watch status:', isCurrentlyWatched);

      if (isCurrentlyWatched) {
        console.log('Unwatching colocation...');
        await axiosLib.delete(`/colocations/${slug}/unwatch`, {
          ...getColocApiCallProperties(),
        });
        showToast.success({
          title: String(t('js.components.watchlist.removed_from_watchlist')),
          text: String(t('js.components.watchlist.property_removed_from_watchlist')),
        });
      } else {
        console.log('Watching colocation...');
        await axiosLib.post(`/colocations/${slug}/watch`, null, {
          ...getColocApiCallProperties(),
        });
        showToast.success({
          title: String(t('js.components.watchlist.added_to_watchlist')),
          text: String(t('js.components.watchlist.property_added_to_watchlist')),
        });
      }

      // Invalidate any related queries to refresh the data
      queryClient.invalidateQueries({
        queryKey: ['colocations'],
      });

      return true;
    } catch (error: any) {
      console.error('Error in handleWatchToggle:', error);

      if (error.response?.status === 401) {
        const redirectUrl = error.response?.data?.redirect_url;
        if (redirectUrl) {
          console.log('Redirecting to:', redirectUrl);
          window.location.href = redirectUrl;
          return false;
        }
      }

      showToast.error({
        title: String(t('js.components.watchlist.error')),
        text: String(t('js.components.watchlist.error_updating_watchlist')),
      });

      return false;
    }
  };

  return { handleWatchToggle };
}; 
